<div class="component-container flex flex-col md:flex-row flex-wrap justify-between items-center w-full">
  <app-search-on-select
    (checkForErrors)="checkForErrors($event)"
    (onNextPage)="clientsOnNextPage()"
    [enableClearSelection]="true"
    [enableMultiple]="true"
    [error]="errorMessages['clientId']"
    [hasNext]="clientOptions.hasNext"
    [loading]="clientOptions.loading"
    [options]="clientOptions.list"
    [parentFormGroup]="form"
    class="input md:w-[20%] w-full"
    controlName="clientId"
    filterControlName="searchClient"
    label="Organization"
    optionsPanelClassName="clients-dropdown"
    placeholder="Select all that apply"
    type="small"
  ></app-search-on-select>
  <app-dropdown
    (checkForErrors)="checkForErrors($event)"
    [enableClearSelection]="true"
    [enableMultiple]="true"
    [error]="errorMessages['status']"
    [options]="statusFilterList"
    [parentFormGroup]="form"
    class="input md:w-[20%] w-full"
    controlName="status"
    label="Group Status"
    placeholder="Select all that apply"
    type="small"
  />
  <app-dropdown
    (checkForErrors)="checkForErrors($event)"
    [enableClearSelection]="true"
    [enableMultiple]="true"
    [error]="errorMessages['type']"
    [options]="groupTypeFilterList"
    [parentFormGroup]="form"
    class="input md:w-[20%] w-full"
    controlName="type"
    label="Type"
    placeholder="Select all that apply"
    type="small"
  />

  <div class="vertical hidden md:block"></div>

  <app-text-input
    (checkForErrors)="checkForErrors($event)"
    (handleSuffixClick)="apply()"
    [error]="errorMessages['searchText']"
    [minLength]="1"
    [parentFormGroup]="form"
    class="input w-full md:w-[20%] search-input"
    controlName="searchText"
    label="Search"
    placeholder="Search Group"
    suffixIcon="search"
    type="small"
  ></app-text-input>

  <div class="vertical hidden md:block"></div>

  <app-primary-button
    (handleClick)="apply()"
    [isDisabled]="!form.dirty"
    class="btn lg:w-[10%] md:w-[15%] w-full"
    type="small"
  >
    Apply
  </app-primary-button>

</div>
